var React = require('react');

function PlusCircle (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"plus-circle"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"Accueil","transform":"translate(-1119.000000, -22.000000)"},React.createElement("g",{"id":"plus-circle","transform":"translate(1119.000000, 22.000000)"},[React.createElement("circle",{"id":"Oval","fill":"#AF9A32","fillRule":"nonzero","cx":"30.5","cy":"30.5","r":"30.5","key":0}),React.createElement("polygon",{"id":"+","fill":"#222453","points":"29 32 21 32 21 29 29 29 29 21 32 21 32 29 40 29 40 32 32 32 32 40 29 40","key":1})])))]);
}

PlusCircle.defaultProps = {"width":"61px","height":"61px","viewBox":"0 0 61 61","version":"1.1"};

module.exports = PlusCircle;

PlusCircle.default = PlusCircle;



// WEBPACK FOOTER //
// ./src/icons/plusCircle.svg